import { render, staticRenderFns } from "./Barrage.vue?vue&type=template&id=1bfde974&scoped=true"
import script from "./Barrage.vue?vue&type=script&lang=js"
export * from "./Barrage.vue?vue&type=script&lang=js"
import style0 from "./Barrage.vue?vue&type=style&index=0&id=1bfde974&prod&lang=css"
import style1 from "./Barrage.vue?vue&type=style&index=1&id=1bfde974&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfde974",
  null
  
)

export default component.exports